import { graphql } from "gql";

const ADMIN_DISTRIBUTION_GROUPS_SET_ACTIVE_MUTATION = graphql(`
  mutation AdminDistributionGroupsSetActive(
    $idList: [ID!]!
    $active: Boolean!
  ) {
    adminDistributionGroupsSetActive(idList: $idList, active: $active) {
      ...DistributionGroup
    }
  }
`);

export default ADMIN_DISTRIBUTION_GROUPS_SET_ACTIVE_MUTATION;
